
import { useState, useRef, useCallback } from 'react';
import { useToast } from "@/components/ui/use-toast";

export const useNoiseCalibration = () => {
  const [isCalibrating, setIsCalibrating] = useState(false);
  const noiseCalibrationSamplesRef = useRef<number[]>([]);
  const { toast } = useToast();

  const startNoiseCalibration = useCallback(async (analyser: AnalyserNode | null) => {
    if (!analyser) return;
    
    setIsCalibrating(true);
    noiseCalibrationSamplesRef.current = [];
    const calibrationDuration = 3000;
    const sampleRate = 100;
    const numberOfSamples = calibrationDuration / sampleRate;

    const collectNoiseSamples = () => {
      if (analyser) {
        const dataArray = new Uint8Array(analyser.frequencyBinCount);
        analyser.getByteFrequencyData(dataArray);
        const averageNoise = dataArray.reduce((a, b) => a + b, 0) / dataArray.length;
        noiseCalibrationSamplesRef.current.push(averageNoise);

        if (noiseCalibrationSamplesRef.current.length >= numberOfSamples) {
          clearInterval(intervalId);
          const averageNoiseLevel = noiseCalibrationSamplesRef.current.reduce((a, b) => a + b, 0) / numberOfSamples;
          console.log('Calibration complete. Average noise level:', averageNoiseLevel);
          setIsCalibrating(false);
          toast({
            title: "Calibração Concluída",
            description: `Nível de ruído médio: ${averageNoiseLevel.toFixed(2)}`,
          });
        }
      }
    };

    const intervalId = setInterval(collectNoiseSamples, sampleRate);
  }, [toast]);

  return {
    isCalibrating,
    startNoiseCalibration
  };
};
